import { useEffect, useRef } from 'react';

/**
 * Smoothly scroll the element into view when `shouldScroll` becomes true.
 * Replaces the legacy `<ScrollToWrapper>` component with a hook that doesn't
 * require an extra DOM wrapper.
 */
export function useScrollIntoView<T extends HTMLElement>(shouldScroll: boolean) {
    const ref = useRef<T | null>(null);

    useEffect(() => {
        if (shouldScroll && ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [shouldScroll]);

    return ref;
}
